// import global variables.
import {SCROLL_ELEMENT, mql, randomString} from '../utils/global';

// TODO: 商品一覧の表示制御の場合のみ処理が複雑になっているので別Classに切り分ける
class ReadMore {
    /**
     * もっと見る
     *
     * @constructor
     * @param {HTMLElement} root - ルートとなる要素
     * @param {Object} options - 設定の変更をする際のオブジェクト
     */
    constructor(root, options) {
        const config = {
            type: 'text', // text or list
            observe: false, // type: 'list'の時のみ有効、属性の変更を監視するか
            visibleLength: 4,
            eachOpenLength: 5, // type: 'list'の時のみ有効、一度のクリックで何個表示させるか（0または0以下の数字で無効化可能）
            setMediaQuery: {
                narrowVisibleLength: 4 // SP画面の時にデフォルトの表示件数を変える。type: 'text'の時は行数、'list'の時は子要素の個数
            },
            className: {
                container: 'js-readmore-text__container',
                wrap: 'p-button-readmore',
                button: 'c-button-readmore',
                text: 'c-button-readmore__label'
            },
            text: {
                open: '続きを読む',
                close: '閉じる'
            },
            prefix: {
                id: 'read-more-'
            },
            isProductList: false // 商品一覧かどうか
        };

        // ルートとなる要素が無い場合は何もしない
        if (!root) {
            return;
        }

        this.config = Object.assign(config, options);
        this.root = root;
        this.container = this.root.querySelector(`.${this.config.className.container}`);
        this.childElements = Array.from(this.container.children);
        this.id = this.container.id || randomString(this.config.prefix.id);
        this.button = this.createButton();
        this.setMediaQuery = this.config.setMediaQuery.narrowVisibleLength > 0;
        this.visibleLength = this.setMediaQuery && mql.state === 'SP' ? this.config.setMediaQuery.narrowVisibleLength : this.config.visibleLength;

        // テキストタイプの場合、1行の高さを取得
        if (this.config.type === 'text') {
            const lineHeight = Number.parseInt(getComputedStyle(this.childElements[0]).getPropertyValue('line-height').replace(/px$/, ''), 10);

            this.visibleHeight = lineHeight * this.visibleLength;
        }


        this.eachOpen = this.config.type === 'list' && this.config.eachOpenLength > 0;
        this.eachOpenLength = this.eachOpen ? this.config.eachOpenLength : 0;
        this.pageHeight = 0;
        this.scrollTop = 0;
        this.animationFrame = null;
        this.isVisibleAll = false;
        this.isUnset = false;
        this.isOpen = false;
        this.isAnimate = false;

        if (this.config.isProductList) {
            this.productShowNum = this.visibleLength;
        }

        // リストタイプ かつ 監視モードが有効の場合、監視を実行
        if (this.config.type === 'list' && this.config.observe) {
            this.setListObserver();

        // リストタイプの場合、監視を実行
        } else if (this.config.type === 'text') {
            this.setTextObserver();
        }

        this.init();
        this.addEvent();
    }

    /**
     * init - 初期化
     * @return {Void}
     */
    init() {
        // idが指定されていない場合は指定
        if (!this.container.id) {
            this.container.id = this.id;
        }

        // テキストタイプの場合、トグルコンテンツ内の要素の属性などを設定
        if (this.config.type === 'text') {
            const paragraphs = this.container.querySelectorAll('p');
            const links = this.container.querySelectorAll('a');
            const blankIcon = '<img src="/assets/images/icon-blank-03.svg" alt="新しいウィンドウで開きます" class="c-icon-blank" width="22" height="18">';

            for (const paragraph of paragraphs) {
                paragraph.classList.add('c-text');
            }

            for (const link of links) {
                link.classList.add('c-link');
                if (link.getAttribute('target') === '_blank') {
                    link.insertAdjacentHTML('beforeend', blankIcon);
                }
            }
        }

        // 非表示処理を実行
        this[this.config.type === 'text' ? 'hideText' : 'hideList']();
    }

    /**
     * createButton - ボタンの生成
     * @return {HTMLElement}
     */
    createButton() {
        const buttonWrap = document.createElement('div');
        const isProduct = this.root.classList.contains('readmore-product');

        buttonWrap.classList.add(this.config.className.wrap);
        buttonWrap.insertAdjacentHTML('beforeend', `<button type="button" class="${this.config.className.button}${isProduct ? ' js-custom-bg-color__target' : ''}" aria-controls=${this.id} aria-expanded="false"><span class="${this.config.className.text}">${this.config.text.open}</span></button>`);

        this.root.insertAdjacentElement('beforeend', buttonWrap);

        return buttonWrap.lastElementChild;
    }

    /**
     * setListObserver - リストタイプの監視を実行
     */
    setListObserver() {
        const observeConfig = {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['hidden']
        };
        const observer = new MutationObserver((mutatuion) => {
            observer.disconnect();

            // アニメーション中の場合は監視を再度有効化し、終了
            if (this.isAnimate) {
                observer.observe(this.container, observeConfig);

                return;
            }

            // 子要素の再取得
            this.childElements = Array.from(this.container.children).filter((child) => !child.hidden);
            this.visibleLength = this.config.visibleLength;

            // すべて表示されている場合
            if (this.isVisibleAll) {
                this.isOpen = false;
                this.isVisibleAll = false;
                this.button.setAttribute('aria-expanded', 'false');
                this.button.firstElementChild.textContent = this.config.text.open;
            }

            // hidden属性の切り替えを検知 かつ 子要素の数よりも表示する数が多い場合、ボタンを非表示にする
            if (mutatuion[0].type === 'hidden' && this.childElements.length <= this.visibleLength) {
                this.isUnset = true;
                this.button.hidden = true;

            // それ以外は初期化を実行
            } else {
                // 初期化されていない場合はボタンを表示する
                if (this.isUnset) {
                    this.isUnset = false;
                    this.button.hidden = false;
                }

                // 非表示処理を実行
                this[this.config.type === 'text' ? 'hideText' : 'hideList']();
            }

            observer.observe(this.container, observeConfig);
        });

        observer.observe(this.container, observeConfig);
    }

    /**
     * setListObserver - テキストタイプの監視を実行
     */
    setTextObserver() {
        const anchor = document.createElement('span');
        const lastIndex = this.childElements.length - 1;

        anchor.classList.add('js-readmore-text__anchor');
        this.childElements[lastIndex].insertAdjacentElement('beforeend', anchor);

        const observeConfig = {
            root: this.container,
            rootMargin: '0px',
            threshold: 1.0
        };
        const observer = new IntersectionObserver((entries) => {
            if (this.isOpen) {
                return;
            }

            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this.button.classList.add('u-none');
                    this.container.style.height = '';

                    return;
                }
                this.button.classList.remove('u-none');
                this.container.style.height = `${this.visibleHeight}px`;
            }
        }, observeConfig);

        observer.observe(anchor);
    }

    /**
     * addEvent - イベントバインド
     */
    addEvent() {
        this.button.addEventListener('click', () => {
            // アニメーション中は無効
            if (this.isAnimate) {
                return;
            }

            this[this.isVisibleAll ? 'close' : 'open']();
        });

        this.container.addEventListener('transitionend', (e) => {
            // height以外のトランジションは受け取らない
            if (e.propertyName !== 'height') {
                return;
            }

            this.transitionAfter();
        });

        // PC・SPで設定を変更する場合
        if (this.setMediaQuery) {
            window.addEventListener(mql.event, () => {
                // フラグを更新
                this.isAnimate = false;
                this.visibleLength = mql.state === 'SP' ? this.config.setMediaQuery.narrowVisibleLength : this.config.visibleLength;

                // 非表示処理を実行
                this[this.config.type === 'text' ? 'hideText' : 'hideList']();
            });
        }
    }

    hideText() {
        this.container.style.maxHeight = `${this.visibleHeight}px`;
    }

    hideList() {
        this.button.parentNode.hidden = false;

        // PC幅で商品一覧の中で目立たせる商品（通常商品に比べて表示領域が広い）がある場合に最後の行に隙間ができてしまうので最後の行が埋まるように商品の表示制御を行う
        if (this.config.isProductList && mql.state === 'PC') {
            this.hideWideProductList();

            // アイテムの個数が表示個数を下回る場合はボタンを非表示
            if (this.childElements.length <= this.productShowNum) {
                this.isVisibleAll = true;
                this.button.parentNode.hidden = true;
            }
        } else {
            for (let i = 0; i < this.childElements.length; i++) {
                if (i > (this.visibleLength - 1)) {
                    this.childElements[i].classList.add('u-none');
                } else {
                    this.childElements[i].classList.remove('u-none');
                }
            }

            // アイテムの個数が表示個数を下回る場合はボタンを非表示
            if (this.childElements.length <= this.visibleLength) {
                this.isVisibleAll = true;
                this.button.parentNode.hidden = true;
            }
        }
    }

    /**
     * PC幅での商品一覧の表示制御
     * PC幅で商品一覧の中で目立たせる商品（通常商品に比べて表示領域が広い）がある場合に最後の行に隙間ができてしまうので最後の行が埋まるように商品の表示制御を行う
     *
     * @return {Void}
     */
    hideWideProductList() {
        /** 目立たせる商品の数 */
        let attentionNum = 0;

        /** 並んでいる枠の数（目立たせる商品は2、通常商品は1で計算） */
        let countNum = 0;

        /** 空いている枠の数 */
        let emptyNum = 0;

        /** 一行に並ぶ枠の数 */
        const COLUMN_NUM = 5;

        const firstShowNum = this.productShowNum;

        this.childElements.forEach((element, i) => {
            if (i + 1 <= this.productShowNum) {
                if (element.classList.contains('p-layout-product--attention')) {
                    attentionNum += 1;
                    countNum += 2;
                } else {
                    countNum += 1;
                }

                if (countNum >= COLUMN_NUM) {
                    emptyNum += countNum % COLUMN_NUM;

                    if (countNum === COLUMN_NUM + 1) {
                        countNum = 2;
                    } else {
                        countNum = 0;
                    }
                }
            }
        });

        // 注目商品がある場合
        if ((this.productShowNum + attentionNum + emptyNum) % COLUMN_NUM !== 0) {
            this.productShowNum = ReadMore.roundUpMultipleOfFive(this.productShowNum + attentionNum + emptyNum) - attentionNum - emptyNum;
        }

        this.childElements.forEach((element, i) => {
            if (i + 1 > this.productShowNum) {
                element.classList.add('u-none');
            } else {
                element.classList.remove('u-none');
            }
        });

        // 空いた枠を埋めるために表示を増やした商品の中に注目商品がある場合は枠が埋まらなくなる場合があるので枠が埋まるまでthis.hideWideProductListを実行させる
        let hasAttentionItem = false;

        this.childElements.forEach((element, i) => {
            if (
                firstShowNum < i + 1 && this.productShowNum >= i + 1 &&
                element.classList.contains('p-layout-product--attention')
            ) {
                hasAttentionItem = true;
            }
        });

        if (hasAttentionItem) {
            this.hideWideProductList();
        }
    }

    /**
     * 5の倍数で切り上げる
     * @return {number} 切り上げた数値
     */
    static roundUpMultipleOfFive(num) {
        return Math.round(num) + (5 - (Math.round(num) % 5));
    }

    /**
     * open - 開く処理
     * @return {Void}
     */
    open() {
        const duration = window.getComputedStyle(this.container).getPropertyValue('transition-duration');

        this.isAnimate = true;
        this.isOpen = true;
        this.scrollTop = SCROLL_ELEMENT.scrollTop;
        this.container.style.height = `${this.container.offsetHeight}px`;
        this.button.parentNode.hidden = true;

        if (this.config.type === 'text') {
            this.container.style.maxHeight = '';
        }

        // n個ずつ表示する設定が有効の場合、その数を追加して表示する
        if (this.eachOpen) {
            this.visibleLength += this.eachOpenLength;

            if (this.config.isProductList) {
                this.productShowNum += this.config.eachOpenLength;
            }

            this.hideList();

        // それ以外はすべて表示する
        } else {
            this.isVisibleAll = true;

            for (const child of this.container.children) {
                child.hidden = false;
                child.classList.remove('u-none');
            }
        }

        // すべて表示された場合、「閉じる」ボタンに変更
        if (this.isVisibleAll) {
            this.button.parentNode.hidden = false;
            this.button.setAttribute('aria-expanded', 'true');
            this.button.firstElementChild.textContent = this.config.text.close;
        }

        const isSameHeight = parseInt(this.container.style.height, 10) === this.container.scrollHeight;

        this.container.style.height = `${this.container.scrollHeight}px`;

        // 開閉する要素の高さに変更がない場合 または transitionの設定がない場合
        if (isSameHeight || (duration === '' || parseFloat(duration) === 0)) {
            this.transitionAfter();
        }

        // スクロール位置を固定する
        window.requestAnimationFrame(this.keepScrollPosition.bind(this));
    }

    /**
     * close - 閉じる処理
     * @return {Void}
     */
    close() {
        const duration = window.getComputedStyle(this.container).getPropertyValue('transition-duration');
        const {offsetHeight} = this.container;

        this.isVisibleAll = false;
        this.isAnimate = true;
        this.isOpen = false;

        this.pageHeight = SCROLL_ELEMENT.scrollHeight;
        this.scrollTop = SCROLL_ELEMENT.scrollTop;

        const {clientHeight} = this.container;

        // テキストタイプの場合
        if (this.config.type === 'text') {
            this.container.style.height = `${this.visibleHeight}px`;
            this.container.style.maxHeight = `${this.visibleHeight}px`;
            this.isAnimate = false;

        // リストタイプの場合
        } else if (this.config.type === 'list') {
            // n個ずつ表示する設定が有効の場合、visibleLength を初期値に戻す
            if (this.eachOpen) {
                this.visibleLength = this.config.visibleLength;
                this.productShowNum = this.visibleLength;
            }
            this.hideList();
            this.container.style.height = `${offsetHeight}px`;
            this.container.style.height = `${Math.min(this.container.clientHeight, clientHeight)}px`;
        }

        this.button.setAttribute('aria-expanded', 'false');
        this.button.firstElementChild.textContent = this.config.text.open;

        const isSameHeight = parseInt(this.container.style.height, 10) === clientHeight;

        // 開閉する要素の高さに変更がない場合 または transitionの設定がない場合
        if (isSameHeight || (duration === '' || parseFloat(duration) === 0)) {
            this.transitionAfter();
        }

        // スクロール位置を固定する
        window.requestAnimationFrame(this.keepScrollPosition.bind(this));
    }

    /**
     * keepScrollPosition - スクロール位置を保持する
     * @return {Void}
     */
    keepScrollPosition() {
        const targetScrollPosition = this.isOpen ? this.scrollTop : this.scrollTop - Math.abs(SCROLL_ELEMENT.scrollHeight - this.pageHeight);

        window.scrollTo(0, targetScrollPosition);

        // transitionが終了したら保持を終了する
        if (!this.isAnimate) {
            window.cancelAnimationFrame(this.animationFrame);

            return;
        }

        this.animationFrame = window.requestAnimationFrame(this.keepScrollPosition.bind(this));
    }

    /**
     * transitionAfter - トランジション後の処理
     * @return {Void}
     */
    transitionAfter() {
        this.isAnimate = false;
        this.container.style.height = '';
    }
}

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => {
    // もっとみる（あらすじ）
    document.querySelectorAll('.js-readmore-text').forEach((element) => new ReadMore(element));

    // もっと見る（関連作品）
    document.querySelectorAll('.js-readmore-list').forEach((element) => new ReadMore(element, {
        type: 'list',
        observe: false,
        visibleLength: 4,
        eachOpenLength: 0,
        setMediaQuery: {
            narrowVisibleLength: 3
        },
        className: {
            container: 'js-readmore-list__container',
            wrap: 'p-button-readmore',
            button: 'c-button-readmore',
            text: 'c-button-readmore__label'
        },
        text: {
            open: '続きを読む',
            close: '閉じる'
        },
        prefix: {
            id: 'read-more-'
        }
    }));

    // もっと見る（関連作品）
    document.querySelectorAll('.js-more').forEach((element) => new ReadMore(element, {
        type: 'list',
        observe: element.firstElementChild.classList.contains('js-sort__container') || element.firstElementChild.classList.contains('js-filter__content'),
        visibleLength: 20,
        eachOpenLength: 10,
        setMediaQuery: {
            narrowVisibleLength: 0
        },
        className: {
            container: 'js-more__container',
            wrap: 'p-button-more',
            button: 'c-button-more',
            text: 'c-button-more__label'
        },
        text: {
            open: 'もっと見る',
            close: '閉じる'
        },
        prefix: {
            id: 'more-'
        },
        isProductList: true
    }));
};
